import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, AutoComplete } from '../../../../../components'
import { STATUS, THEMES } from '../../../../../utils'

/**
 * Contact Sidebar Filters Component
 */
class ContactSidebarFilters extends PureComponent {
  /**
   * Trigger filter update for partial GDPR flag change
   * @param isChecked
   */
  onPartialGDPRChange (isChecked) {
    const { onFilterChange } = this.props
    onFilterChange({ partialGDPR: isChecked, page: 1 })
  }

  /**
   * Trigger filter update for status change
   * @param option
   */
  onStatusChange (option) {
    const { onFilterChange } = this.props
    onFilterChange({ status: option && option.value, page: 1 })
  }

  /**
   * Render Activity Filters
   * @returns {XML}
   */
  render () {
    const { filters } = this.props
    const { partialGDPR, status } = filters

    return (
      <section>
        <div className='field field--spaced'>
          <Checkbox
            theme={THEMES.WHITES}
            id='partialGDPR'
            label='Partial GDPR'
            isChecked={partialGDPR}
            onChange={this.onPartialGDPRChange.bind(this)} />
        </div>
        <div className='field field--grouped'>
          <AutoComplete
            theme={THEMES.WHITES}
            placeholder='Status'
            value={STATUS.find((option) => option.value === status) || status}
            options={STATUS}
            onChange={this.onStatusChange.bind(this)}
            searchable={false}
            clearable={false} />
        </div>
      </section>
    )
  }
}

ContactSidebarFilters.propTypes = {
  filters: PropTypes.object.isRequired,
}

export default ContactSidebarFilters
